import { Card } from "semantic-ui-react";
import { colors } from "../style";
import { ui } from "./ui";

// Sits inside a Semantic Card.Group, so it stays a Card for the grid spacing
function StatCard({ label, value, colour, loading, help }) {
  return (
    <Card
      style={{
        minHeight: "104px",
        background: colors.surface,
        boxShadow: `inset 3px 0 0 ${colour}, 0 0 0 1px ${colors.border}`,
      }}
    >
      <Card.Content
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "6px",
          padding: "16px 18px",
        }}
      >
        {label && <div style={ui.label}>{label}</div>}
        <div
          className={loading ? "sk-pulse" : undefined}
          style={{
            fontSize: "28px",
            fontWeight: 700,
            lineHeight: 1.1,
            color: loading ? colors.textFaint : colour,
          }}
        >
          {loading ? "N/A" : value}
        </div>
        {help && (
          <small style={{ ...ui.muted, fontSize: "12px" }}>{help}</small>
        )}
      </Card.Content>
    </Card>
  );
}

export default StatCard;
